// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"165a285d","706":"88e9b000"}[chunkId] + ".chunk.js";
};